// extracted by mini-css-extract-plugin
export default {"root":"CompletedHomeworkPill_root__gMPln","name":"CompletedHomeworkPill_name__u7gOw","downloadBtn":"CompletedHomeworkPill_downloadBtn__ARmhg index_btn-icon__IStVw"};